import {LOCALE_ID, NgModule} from '@angular/core';
import localeHr from '@angular/common/locales/hr';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from './shared/interceptor/auth.interceptor';
import {DatePipe, registerLocaleData} from '@angular/common';
import {MondayFirstDateAdapter} from './shared/misc/monday-first-date-adapter';
import {DateAdapter} from '@angular/material';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {appRoutes} from './app-routes';
import {SharedDataService} from './shared/services/shared-data.service';
import {PaywayService} from './shared/services/payway.service';
import {UtilService} from './shared/services/util.service';
import {AuthService} from './shared/services/auth.service';
import {TicketBookingService} from './shared/services/ticket-booking.service';
import {TreasuryService} from './shared/services/treasury.service';
import {AdditionalPurchaseService} from './shared/services/additional-purchase.service';
import {LocalStorageDataServiceService} from './shared/services/local-storage-data-service.service';
import {BuyerService} from './shared/services/buyer.service';
import {StorageService} from './shared/services/storage.service';
import {AuthenticationGuard} from './shared/services/authentication-guard.service';
import {SpinnerComponent} from './shared/components/spinner/spinner.component';

registerLocaleData(localeHr, 'hr');

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    RouterModule.forRoot(appRoutes, {useHash: false}),
  ],
  declarations: [AppComponent],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: LOCALE_ID, useValue: 'hr'},
    {provide: DateAdapter, useClass: MondayFirstDateAdapter},
    DatePipe,
    SharedDataService,
    PaywayService,
    UtilService,
    AuthService,
    TicketBookingService,
    TreasuryService,
    AdditionalPurchaseService,
    LocalStorageDataServiceService,
    BuyerService,
    StorageService,
    AuthenticationGuard
  ],
  entryComponents: [SpinnerComponent],
  bootstrap: [AppComponent],
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts